import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

declare function phoneOrEmail(): any;

@Component({
  selector: 'app-cheat-sheet',
  templateUrl: './cheat-sheet.component.html',
  styleUrls: ['./cheat-sheet.component.css']
})
export class CheatSheetComponent implements OnInit {

  phoneOption: boolean = false;
  phoneCheck = "checked";
  emailCheck: string;

  constructor(private _location: Location, private router: Router) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.phoneOption = phoneOrEmail(), 1000
    });
    //this.ccService.destroy();
  }

  scrollTo(id: string) {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  }
  
  backClicked() {
    if (this.router.navigated) {
      this.router.navigate(['/'])
    } else {
      this.router.navigate(['/'])
    }

  }

  selectedOption() {
    this.phoneOption = phoneOrEmail()
    if (this.phoneOption == true) {
      this.phoneCheck = "checked";
      this.emailCheck = '';
    }
    else {
      this.emailCheck = "checked";
      this.phoneCheck = '';
    }
  }
}
